import { useState } from "react";
import { useIpc } from "../ipc/IpcProvider";
import { toCsv, suggestCsvName } from "./csv";
import type { EngineOverviewDto } from "../ipc/types";

/**
 * Exportación a CSV/Excel (item 7) de una tabla de motor (columnas + filas). Cada fila son 4 celdas
 * en el orden de las columnas: primary, secondary, estado, monto — igual que se muestra en pantalla.
 * Devuelve el handler, el estado ocupado y un banner listo para renderizar.
 */
export function useCsvExport(overview: Pick<EngineOverviewDto, "title" | "columns" | "rows">): {
  exportCsv: () => Promise<void>;
  exporting: boolean;
  banner: JSX.Element | null;
} {
  const client = useIpc();
  const [msg, setMsg] = useState<string | null>(null);
  const [exporting, setExporting] = useState(false);

  const exportCsv = async (): Promise<void> => {
    setExporting(true); setMsg(null);
    const rows = overview.rows.map((r) => [r.primary, r.secondary, r.status.label, r.amount]);
    const res = await client.saveExport(suggestCsvName(overview.title), toCsv(overview.columns, rows));
    setExporting(false);
    if (!res.ok) { if (res.error.code !== "cancelled") setMsg(res.error.message); return; }
    setMsg(`Informe exportado a: ${res.value.path}`);
  };

  const banner = msg ? (
    <div className="callout" style={{ marginBottom: "var(--sp-4)" }}>
      <div className="bar" />
      <div className="body">{msg}</div>
    </div>
  ) : null;

  return { exportCsv, exporting, banner };
}
